import { render, staticRenderFns } from "./Advert7.vue?vue&type=template&id=16dab792&scoped=true&"
import script from "./Advert7.vue?vue&type=script&lang=ts&"
export * from "./Advert7.vue?vue&type=script&lang=ts&"
import style0 from "./Advert7.vue?vue&type=style&index=0&id=16dab792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dab792",
  null
  
)

component.options.__file = "Advert7.vue"
export default component.exports